import React, { PropTypes, Component } from 'react';
import { Button, ButtonToolbar, Form, FormGroup, InputGroup, FormControl, Glyphicon } from 'react-bootstrap';
//import AutoSuggest from 'react-autosuggest';
import hgIcon from '../assets/icons/hydrogeology-icon.png';
import bgcIcon from '../assets/icons/biogeochemistry-icon.png';
import vIcon from '../assets/icons/vegetation-icon.png';
import cIcon from '../assets/icons/climate-icon.png';
import mIcon from '../assets/icons/modeloutput-icon.png';
import ecoIcon from '../assets/icons/vegetation-icon.png'

class CategoryButton extends Button {
    constructor(props) {
        super(props);
        this.state = {active: false};
        this.clickHandler = this.clickHandler.bind(this);
        this.onButtonChange = this.props.onButtonChange.bind(this);
    }
    
    clickHandler(e) {
        e.preventDefault();
        this.onButtonChange(this.props.category);
        this.setState({active: !this.state.active});
    }
    
    render() {
        return (
            <Button bsClass='btn btn-custom' active={this.state.active} onClick={this.clickHandler}>
                <img className="measurement-icon" src={this.props.icon} alt={""}/>
                <span>{this.props.label}</span>
            </Button>
        );
    }
}

class Filters extends Component {
    constructor(props) {
        super(props);
        this.handleCategoryFilterInputChange = this.handleCategoryFilterInputChange.bind(this);
        this.handleSearchFilterUpdate = this.handleSearchFilterUpdate.bind(this);
        this.handleSearchKeyPress = this.handleSearchKeyPress.bind(this);
        this.onCategoryFilterInput = props.onCategoryFilterInput.bind(this);
        this.onSearchFilterInput = props.onSearchFilterInput.bind(this);
        this.state = {ftypes: new Set(), search: null};
    }
    
    handleCategoryFilterInputChange(c) {      
        if (this.state.ftypes.has(c)) {
            this.state.ftypes.delete(c);
        }
        else {
            this.state.ftypes.add(c);
        }

        this.onCategoryFilterInput(this.state.ftypes);
    }
    
    handleSearchKeyPress(e) {
        if (e.which === 13) {
            e.preventDefault();
        }
    }

    handleSearchFilterUpdate(c) {
        this.onSearchFilterInput(c.target.value);
        this.setState({search: c.target.value});
    }

    hasFilter(f) {
        if (this.state.ftypes) {
            return this.state.ftypes.has(f);    
        }
        else {
            return false;
        }
    }
    
    render() {        
        return (
            <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 filters' style={{paddingTop: 5 + 'px', paddingBottom: 5 + 'px', backgroundColor: "#f6f6f6"}}>
                <h4 style={{fontSize: 14 + 'px'}}>Filters</h4>
                <ButtonToolbar>
                    <CategoryButton category={"hydrogeology"} label={"Hydrogeology"} icon={hgIcon}
                     onButtonChange={this.handleCategoryFilterInputChange} />
                    <CategoryButton category={"biogeochemistry"} label={"Biogeochemistry"} icon={bgcIcon}
                     onButtonChange={this.handleCategoryFilterInputChange} />
                    <CategoryButton category={"vegetation"} label={"Vegetation"} icon={vIcon}
                     onButtonChange={this.handleCategoryFilterInputChange} />
                    <CategoryButton category={"climate"} label={"Climate"} icon={cIcon}
                     onButtonChange={this.handleCategoryFilterInputChange} />
                    <CategoryButton category={"modeloutput"} label={"ModelOutput"} icon={mIcon}
                     onButtonChange={this.handleCategoryFilterInputChange} />
                    <Form componentClass="fieldset" className='pull-right' inline style={{marginRight: 15}}>
                        <FormGroup style={{width: 30 + 'vw'}}>
                            <InputGroup>
                                <FormControl type="text" placeholder="Search for sites"
                                    onChange={this.handleSearchFilterUpdate}
                                    onKeyPress={this.handleSearchKeyPress}
                                    style={{width: 28 + 'vw'}}
                                />
                                <InputGroup.Addon bsStyle='primary' style={{width: 2 + 'vw'}}>
                                    <Glyphicon glyph="search" />
                                </InputGroup.Addon>
                            </InputGroup>
                        </FormGroup>
                    </Form>
                </ButtonToolbar>
            </div>
        );
    }
}

Filters.propTypes = {
    onSearchFilterInput: PropTypes.func,
    onSearchSubmit: PropTypes.func,
    onCategoryFilterInput: PropTypes.func
};

export default Filters;


// WEBPACK FOOTER //
// ./src/filters/Filters.js